import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import CloseBar from '../components/CloseBar';

export default function RegisterPage({ onLogin }) {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ email: '', password: '', tariff: 'personal', name: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const { data } = await api.register(form);
      localStorage.setItem('pendingTariff', form.tariff);
      onLogin(data.access_token, data.paid);
    } catch (err) {
      setError(err.response?.data?.detail || 'Ошибка регистрации');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.box}>
        <CloseBar />
        <div style={styles.logo}>✦ AstraData</div>
        <h2 style={styles.title}>Создать аккаунт</h2>

        {/* Выбор тарифа */}
        <div style={styles.tariffs}>
          {[
            { key: 'personal', label: 'Личный', price: '$49', desc: 'Только для себя — навсегда' },
            { key: 'professional', label: 'Профессиональный', price: '$149', desc: 'Неограниченно клиентов' },
          ].map(t => (
            <div key={t.key} onClick={() => setForm({...form, tariff: t.key})}
              style={{...styles.tariffCard, ...(form.tariff === t.key ? styles.tariffActive : {})}}>
              <div style={styles.tariffName}>{t.label}</div>
              <div style={styles.tariffPrice}>{t.price}</div>
              <div style={styles.tariffDesc}>{t.desc}</div>
            </div>
          ))}
        </div>

        <form onSubmit={submit} style={styles.form}>
          <div className="input-group">
            <label>Имя</label>
            <input className="input" placeholder="Ваше имя"
              value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
          </div>
          <div className="input-group">
            <label>Email</label>
            <input className="input" type="email" placeholder="you@email.com"
              value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
          </div>
          <div className="input-group">
            <label>Пароль</label>
            <input className="input" type="password" placeholder="Минимум 8 символов"
              value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
          </div>

          <p style={styles.agree}>
            Нажимая кнопку ниже, вы создаёте аккаунт и переходите к покупке доступа.
            Доступ — пожизненный, разовая покупка (не подписка). Подробнее:{' '}
            <a href="https://astrolog.estate-ua.com.ua/privacy.html" target="_blank" rel="noreferrer" style={{color:'#a78bfa'}}>политика конфиденциальности</a>.
          </p>

          {error && <p style={styles.error}>{error}</p>}

          <button className="btn btn-primary" type="submit" disabled={loading} style={{width:'100%'}}>
            {loading ? 'Создаём аккаунт...' : 'Создать аккаунт и продолжить'}
          </button>
        </form>

        <p style={styles.footer}>
          Уже есть аккаунт? <Link to="/login" style={styles.link}>Войти</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page:        { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  box:         { width: '100%', maxWidth: 480, background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 20, padding: 40 },
  logo:        { fontSize: 22, fontWeight: 700, color: '#a78bfa', marginBottom: 16, textAlign: 'center' },
  title:       { fontSize: 22, marginBottom: 20, textAlign: 'center' },
  tariffs:     { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 24 },
  tariffCard:  { background: '#12122a', border: '2px solid #2a2a4a', borderRadius: 12, padding: 16, cursor: 'pointer', transition: 'all 0.2s' },
  tariffActive:{ borderColor: '#6c63ff', background: 'rgba(108,99,255,0.1)' },
  tariffName:  { fontSize: 13, fontWeight: 700, marginBottom: 4 },
  tariffPrice: { fontSize: 22, fontWeight: 700, color: '#a78bfa', marginBottom: 4 },
  tariffDesc:  { fontSize: 11, color: '#666680' },
  form:        { display: 'flex', flexDirection: 'column', gap: 14 },
  agree:       { fontSize: 11, color: '#555570', lineHeight: 1.5 },
  error:       { color: '#e74c3c', fontSize: 13, textAlign: 'center' },
  footer:      { marginTop: 20, textAlign: 'center', fontSize: 14, color: '#666680' },
  link:        { color: '#a78bfa', textDecoration: 'none' },
};
